// extracted by mini-css-extract-plugin
module.exports = {"htmlBlockContainer":"HTMLBlock_htmlBlockContainer__Zwiv0","editor":"HTMLBlock_editor__7Jyuk","editTitle":"HTMLBlock_editTitle__TCYE9"};